import React, { useCallback, useEffect } from 'react';
import PropTypes from 'prop-types';

import { useReportsActions, useAlerts, ID, STATUS, EXPAND, SUB_PATIENT } from 'store/reports';
import Button from 'components/Button';

const RecreateButton = ({ id, setData, disabled }) => {
  const { saveReport } = useReportsActions();
  const { action, loading, success } = useAlerts(saveReport);

  const onClick = useCallback(() => action({ [ID]: id, [STATUS]: 6 }, { [EXPAND]: [SUB_PATIENT] }), [id, action]);

  useEffect(() => {
    if (success) setData(success);
  }, [setData, success]);

  return (
    <Button type="button" onClick={onClick} color="success" disabled={disabled || loading}>
      Bericht neu senden
    </Button>
  );
};

RecreateButton.propTypes = {
  id: PropTypes.string.isRequired,
  setData: PropTypes.func.isRequired,
  disabled: PropTypes.bool.isRequired,
};

export default RecreateButton;
